import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { Page, LayoutSingleColumn, Footer } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';

import facebookImage from '../../assets/vivianlab-brandImage.png';
import twitterImage from '../../assets/vivianlab-brandImage.png';
import { withViewport } from '../../util/uiHelpers';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { useConfiguration } from '../../context/configurationContext';

import css from './CompaniesPage.module.css';
import SectionHero from './SectionHero';
import SectionBestTalent from './SectionBestTalent';
import { isLocaleGreek } from '../../util/genericHelpers';

export const CompaniesPageComponent = props => {
  const { intl, scrollingDisabled } = props;
  const config = useConfiguration();

  const [scroll, setScroll] = useState(false);
  const siteTitle = config.marketplaceName;
  const schemaTitle = intl.formatMessage({ id: 'CompaniesPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({
    id: 'CompaniesPage.schemaDescription',
  });

  const schemaImage = `${config.marketplaceRootURL}${facebookImage}`;
  useEffect(() => {
    let isMounted = true;
    if (typeof window !== 'undefined') {
      const handleScroll = () => {
        if (isMounted) {
          setScroll(window.scrollY > 0);
        }
      };
      window.addEventListener('scroll', handleScroll);
      return () => {
        isMounted = false; // This is the cleanup for event listener
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);
  const isHeaderSticky = scroll ? css.sticky : '';
  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        {
          url: `${config.marketplaceRootURL}${twitterImage}`,
          width: 600,
          height: 314,
        },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn
        isStaticPage={true}
        className={css.pageRoot}
        topbar={<TopbarContainer isFullWidthHeader isPostLandingPage />}
        footer={<Footer />}
      >
        <div className={css.pageContent}>
          <SectionHero />
          <SectionBestTalent />
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool, object } = PropTypes;

CompaniesPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

const CompaniesPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withViewport,
  injectIntl
)(CompaniesPageComponent);

export default CompaniesPage;
